export default "__VITE_ASSET__Cg12kwlf__"